import { render } from "./App.vue?vue&type=template&id=d81e4b38"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d81e4b38&lang=css"
script.render = render

export default script